class Config {

    constructor() {
        this.CSRF_TOKEN = document.querySelector('meta[name="csrf-token"]').content;
        this.APP_MAIN = document.getElementById('app-main');
        this.URL_ROOT = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        this.URL_SIGN_IN = this.URL_ROOT + '/manage/staffs/sign_in';
        this.URL_COMPLAINTS = this.URL_ROOT + '/manage/complaints';
        this.COOKIE_NAME_NOTIFICATION = 'notification';
    }

}
export { Config }
